import { useEffect } from 'react';

// import { useGetS3VideoUrl } from 'lib/hooks/queries/resource/useGetS3VideoUrl';

import VideoPlayer from 'components/shared/VideoPlayer/VideoPlayer';

const TrainingVideo = ({ setHeaderButtonProps, addFooterActions, onNext }) => {
  // const { data } = useGetS3VideoUrl();
  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Continue',
        onClick: onNext
      }
    ]);
  }, []);

  return (
    <div className="w-full overflow-hidden rounded-lg">
      <div className="h-[400px]">
        {/* {data?.videoUrl && ( */}
        <VideoPlayer
          // src={data.videoUrl}
          src="https://www.youtube.com/watch?v=9-3ipdJAKNs"
          onEvent={() => {}}
        />
      </div>
      {/* )} */}
    </div>
  );
};

export default TrainingVideo;
